<template>
  <section
    class="
      tw-flex
      tw-flex-col
      tw-gap-4
      tw-rounded-lg
      tw-border
      tw-border-solid
      tw-border-sf-slate-lighter-1
      tw-bg-white
      tw-p-6
    "
  >
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
      <h3 class="tw-m-0 tw-text-base tw-font-medium tw-text-sf-slate-dark-2">
        {{ title }}
      </h3>
      <slot name="action" />
    </div>
    <slot />
  </section>
</template>

<script setup lang="ts">
defineOptions({ name: 'PanelCard' })

defineProps<{ title: string }>()
</script>
